import { emptyArray } from 'ui-components/default-props/empty';

import { ADD_HOTKEY, REMOVE_HOTKEY, SET_HOTKEYS } from './constants';

export const INITIAL_STATE = {
  hotkeys: emptyArray,
};

const actionMap = {
  [ADD_HOTKEY]: (state, { payload: { hotkey } }) => ({
    ...state,
    hotkeys: [...state.hotkeys, hotkey],
  }),

  [REMOVE_HOTKEY]: (state, { payload: { hotkey } }) => ({
    ...state,
    hotkeys: state.hotkeys.filter((record) => record !== hotkey),
  }),

  [SET_HOTKEYS]: (state, { payload: { hotkeys } }) => ({
    ...state,
    hotkeys,
  }),
};

export const reducer = (state, action) => (actionMap[action.type] ? actionMap[action.type](state, action) : state);
